import {
  FORM_ITEM__DATE,
  FORM_ITEM__SINGLE_LINE,
  FORM_STATUS__EDIT,
  FORM_STATUS__FILL,
  FORM_STATUS__READ,
  PERMISSION__READ,
  FORM_ITEM__CHECKBOX, CHOOSE_TYPE_SUB_SUB
} from '../../types'
import RySelectPopup from "../../../component/RySelectPopup"
import {formatDate} from "../../../../assets/js/Untis"
import context from "../../../main";

export const current = {
  props: {
    value: Object,
    type: Number,
    row: Object,
    index: Number,
  },
  data () {
    return {
      current: this.value,
      formSet: this.value.root,
      currentRow: this.row,
      dataId: this.value.dataId,

      timer: null,
      taskId: '',
      taskInfoMap: {}, // taskId为key存一些数据，轮询结果后需要用到，例如pluginCoreJson，rowIdx
      pluginCoreJson: {},
      loading: false
    }
  },
  components: {
    RySelectPopup
  },
  created() {
    // 接收消息分发
    if (this.current.pluginConfig && this.current.pluginConfig.entryId && !this.current.pluginConfig.waitResult) {
      document.addEventListener('PLUGIN_RESULT_RECEIVED', this.receiveNewMessage)
    }
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    if (this.current.pluginConfig && this.current.pluginConfig.entryId && !this.current.pluginConfig.waitResult) {
      document.removeEventListener('PLUGIN_RESULT_RECEIVED', this.receiveNewMessage)
    }
  },
  computed: {

    // 宽度样式
    formItemContentStyle () {
      let width = ''
      if (this.type !== FORM_STATUS__EDIT) {
        width = `100%`
      } else {
        width = this.current.singleLine ? `${this.current.percent}%` : '100%'
      }
      return {
        width: width
      }
    },

    // 是否是显示内容状态
    isRead () {
      return this.type === FORM_STATUS__READ
    },

    // 输入状态
    isFill () {
      return this.type === FORM_STATUS__FILL
    },

    // 编辑状态
    isEdit () {
      return this.type === FORM_STATUS__EDIT
    },

    // 是否只读
    isReadOnly () {
      // 权限只读
      return this.current.parent.permission === PERMISSION__READ  ||
        this.current.permission === PERMISSION__READ ||
        // 非可编辑
        !this.current.edit || !this.current.displayInfo.edit
    },

    // 是否展示必填提示
    isShowRequiredText () {
      const value = this.current.valueToString(this.row[this.dataId])
      return this.type === FORM_STATUS__FILL
        && this.current.required
        && !value.length
    },

    isNormalStyle() {
      return this.formSet.customFormStyle.mobileLayout === 'NORMAL'
    }
  },

  methods: {
    controlChange () {
      console.log('controlChange', this.current, this.currentRow)
      this.current.revised('change')
      this.current.parent.modified = true
      this.current.parent.computeDisplayResults(this.index)

      const formSet = this.current.root
      // 字段值变化发通知
      const changeFlowEvent = new CustomEvent('FORM_FIELD_DATA_CHANGE', {detail: {
          formId: formSet.formId,
          fieldId: this.current.dataId,
        }})
      document.dispatchEvent(changeFlowEvent)

      if (this.current.pluginConfig && this.current.pluginConfig.entryId) {
        return
      }
      if (this.current.dependSubmit && formSet) {
        const version = new Date().getTime()
        this.$store.dispatch('actionTmpSubmit', {
          companyId: formSet.companyId,
          appId: formSet.appId,
          formId: formSet.formId,
          rowIdx: this.index + 1,
          instanceId: formSet.instanceId,
          fieldId: this.current.dataId,
          tmpTopic: formSet.tmpTopic,
          data: formSet.getValues(),
          version
        }).then(res => {
          formSet.lastSubmitTime = version
          formSet.submitMap[version] = {
            rowIdx: this.index + 1,
            fieldId: this.current.dataId
          }
        })
      }
    },

    submitData() {
      if (!this.current.pluginConfig || !this.current.pluginConfig.entryId) {
        return
      }
      this.loading = true
      const formSet = this.current.root
      this.$store.dispatch('actionApplyPluginSubmit', {
        companyId: formSet.companyId,
        appId: formSet.appId,
        formId: formSet.formId,
        entryId: this.current.pluginConfig.entryId,
        rowIdx: this.index + 1,
        fieldId: this.current.dataId,
        tmpTopic: formSet.tmpTopic,
        data: formSet.getValues(),
        instanceId: formSet.instanceId,
        context: {
          dataId: this.current.dataId,
          index: this.index + 1
        }
      }).then(res => {
        if (res.resultType === 'CYCLE') {

          this.taskInfoMap[res.taskId] = {
            pluginCoreJson: res.pluginCoreJson,
            index: this.index
          }
          this.pluginCoreJson = res.pluginCoreJson
          this.taskId = res.taskId

          if (this.current.pluginConfig.showDialog) {
            if (this.$refs.rySelectPopup) {
              this.$refs.rySelectPopup.open()
            }
          }

          this.timer = setTimeout(() => {
            this.getResult()
          }, 300)
        } else if (res.resultType === 'CHECK') {
          this.current.root.setError(res.resultInfo)
          if (res.resultInfo.errorMessage) {
            context.$toast.fail(res.resultInfo.errorMessage)
          }
          this.loading = false
        } else {
          // 消息下类型，设置5秒超时等待
          setTimeout(() => {
            this.loading = false
          }, 5000)
        }
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },

    getResult() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.loading = true
      this.$store.dispatch('actionApprovalCommentSignResult', {
        taskId: this.taskId
      }).then(res => {

        const taskInfo = this.taskInfoMap[res.taskId]

        if (res.executeFinish === 1) {
          this.loading = false

          if (this.current.pluginConfig.showDialog) {
            // 弹框选择选项
            const showDataList = []
            res.resultInfo.forEach(item => {
              let showData = {
                title: {},
                image: {},
                content: [],
                item
              }

              showData.title = {
                showData: item[taskInfo.pluginCoreJson.showTitle],
                fieldId: taskInfo.pluginCoreJson.showTitle,
                type: 'title'
              }

              taskInfo.pluginCoreJson.showInfoList.forEach(fieldId => {
                showData.content.push({
                  showData: item[fieldId],
                  type: FORM_ITEM__SINGLE_LINE,
                  dataType: 'String',
                  fieldId,
                  fieldTitle: taskInfo.pluginCoreJson.titleMap[fieldId]
                })
              })

              showDataList.push(showData)
            })
            if (this.$refs.rySelectPopup) {
              this.$refs.rySelectPopup.setDataList(showDataList)
            }
          } else {
            if (res.resultInfo && res.resultInfo.length) {
              const formSet = this.current.root
              // 替换选择项option
              // const field = formSet.fields[taskInfo.pluginCoreJson.successChangeField]
              // if (field && field.hasOwnProperty('options')) {
              //   field.options.splice(0, field.options.length, ...res.resultInfo)
              // }
              this.current.parent.updateOptions({
                opts: res.resultInfo,
                rowIdx: taskInfo.index + 1,
                fieldId: taskInfo.pluginCoreJson.successChangeField
              })

              // 赋值
              let value = ''
              // 如果是时间控件，需要formatDate
              if (this.current.pluginConfig.extraMap &&
                this.current.pluginConfig.extraMap.hasOwnProperty('queryFieldType') &&
                this.current.pluginConfig.extraMap.queryFieldType === FORM_ITEM__DATE) {
                res.resultInfo.forEach(opt => {
                  if (opt.id !== '0') {
                    opt.id = formatDate(Number(opt.id))(taskInfo.pluginCoreJson.dateFormat)
                    opt.optionName = formatDate(Number(opt.optionName))(taskInfo.pluginCoreJson.dateFormat)
                  }
                })
              }

              if (taskInfo.pluginCoreJson.chooseOption === 'FIRST') {
                // 默认选择第一个
                value = res.resultInfo[0].id
                if (field.type === FORM_ITEM__CHECKBOX) {
                  this.current.parent.replaceValue({
                    val: [value],
                    rowIdx: taskInfo.index + 1,
                    fieldId: taskInfo.pluginCoreJson.successChangeField
                  })
                } else {
                  this.current.parent.replaceValue({
                    val:value,
                    rowIdx: taskInfo.index + 1,
                    fieldId: taskInfo.pluginCoreJson.successChangeField
                  })
                }
              } else if (taskInfo.pluginCoreJson.chooseOption === 'LAST') {
                // 默认选择最后一个
                value = res.resultInfo[res.resultInfo.length - 1].id
                if (field.type === FORM_ITEM__CHECKBOX) {
                  this.current.parent.replaceValue({
                    val: [value],
                    rowIdx: taskInfo.index + 1,
                    fieldId: taskInfo.pluginCoreJson.successChangeField
                  })
                } else {
                  this.current.parent.replaceValue({
                    val: value,
                    rowIdx: taskInfo.index + 1,
                    fieldId: taskInfo.pluginCoreJson.successChangeField
                  })
                }
              } else if (taskInfo.pluginCoreJson.chooseOption === 'ALL') {
                // 默认全选，仅复选框
                value = res.resultInfo
                if (field.type === FORM_ITEM__CHECKBOX) {
                  this.current.parent.replaceValue({
                    val: value.map(opt => opt.id),
                    rowIdx: taskInfo.index + 1,
                    fieldId: taskInfo.pluginCoreJson.successChangeField
                  })
                }
              }

              this.refreshSubmit()
            } else {
              this.$toast.fail('查询结果为空')
            }
          }

          clearTimeout(this.timer)
          this.timer = null
        } else if (res.executeFinish === -1) {
          this.$toast.fail(res.errorMsg)

          if (this.current.pluginConfig.showDialog) {
            if (this.$refs.rySelectPopup) {
              this.$refs.rySelectPopup.setError(res.errorMsg)
            }
          } else {
            // 失败清空指定控件value
            const formSet = this.current.root
            const values = {}
            taskInfo.pluginCoreJson.failClearFieldList.forEach(fieldId => {
              values[fieldId] = null
            })
            formSet.setValues(values)
          }

          this.loading = false
        } else {
          this.timer = setTimeout(() => {
            this.getResult()
          }, 1000)
        }
      }).catch(console.error)
    },

    selectComplete(selectList) {
      console.log(selectList)
      if (!selectList || !selectList.length) {
        return
      }
      const item = selectList[0]
      const formSet = this.current.root
      if (this.pluginCoreJson.chooseType === CHOOSE_TYPE_SUB_SUB) {
        Object.keys(this.pluginCoreJson.queryDetail).forEach(key => {
          const value = item.item[key]
          const fieldId = this.pluginCoreJson.queryDetail[key]
          // this.currentRow[fieldId] = value
          this.current.parent.replaceValue({
            val: value,
            rowIdx: this.index + 1,
            fieldId: fieldId
          })
        })
      } else {
        const values = {}
        Object.keys(this.pluginCoreJson.queryDetail).forEach(key => {
          const value = item.item[key]
          const fieldId = this.pluginCoreJson.queryDetail[key]
          values[fieldId] = value
        })
        formSet.setValues(values)
      }

      this.refreshSubmit()
    },
    refreshSubmit() {
      if (this.pluginCoreJson.needRefreshSubmit) {
        const formSet = this.current.root
        this.$store.dispatch('actionFormDefaultSubmitData', {
          appId: formSet.appId,
          formId: formSet.formId,
          data: formSet.getValues()
        }).then(res => {
          formSet.setValues(res)
        }).catch(console.error)
      }
    },

    receiveNewMessage(e) {
      console.log('PLUGIN_RESULT_RECEIVED--', e)
      if (e.detail) {
        const {context, content} = e.detail

        if (context && this.current.dataId === context.dataId && this.index + 1 === context.index) {
          this.loading = false
        }
      }
    }
  }
}

